import { name } from 'file-loader'
import App from '../App'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

//首页
const Home = () => import('@/page/home/Home')

//新闻
const newMore = () => import('@/page/home/child/child/newMore')
// const NewsDetail = () => import('@/page/home/child/child/NewsDetail')
const NewsDetail = () => import('@/page/resint/precinct/info')

//奖学金
const activityJxj = () => import('@/page/home/child/child/activityJxj')

// 通路图
const xhtlMore = () => import('@/page/home/child/child/xhtlMore')
const xhtlDeta = () => import('@/page/home/child/child/xhtlDeta')

// 市场展会活动
const Exhibition = () => import('@/page/resint/exhibition/Exhibition')
const TradeShow = () => import('@/page/resint/exhibition/child/TradeShow')

//校园行活动
const CampusTour = () => import('@/page/resint/campusTour/CampusTour')

//联系我们
const ContactUs = () => import('@/page/resint/contactUs/ContactUs')

//技术服务
const TechnicalServices = () => import('@/page/resint/technicalServices/TechnicalServices')
const TechnicalServicesInfo = () => import('@/page/resint/technicalServices/child/TechnicalServicesInfo')

//试用装
const SampleSack = () => import('@/page/resint/sampleSack/SampleSack')
const SampleFeedback = () => import('@/page/resint/sampleSack/child/SampleFeedback')
const SampleList = () => import('@/page/resint/sampleSack/child/SampleList')

//无限制反馈
const NoLimitFeedback = () => import('@/page/resint/sampleSack/child/NoLimitFeedback')

//展会抽奖活动信息征集
const LotteryContest = () => import('@/page/resint/LotteryContest/index.vue')

//电影票申请
const newYearHelp = () => import('@/page/resint/newYearHelp/index')
const newYearList = () => import('@/page/resint/newYearHelp/child/NewYearList')

//精品课问卷https://m.solarbio.com/#/Premium_courses
const PremiumCourses = () => import('@/page/resint/premiumCourses/index')

//三月活动
const MarchActivities = () => import('@/page/resint/Activities/MarchActivities/index')

//抗体申请
const KtApply = () => import('@/page/resint/ktApply/KtApply')

// 二维码（一物一码）
const QrCode = () => import('@/page/resint/QrCode/QrCode')
const QrDetails = () => import('@/page/resint/QrCode/QrDetails')

const QrCodecs = () => import('@/page/resint/QrCodeCs/QrCode')
const QrDetailscs = () => import('@/page/resint/QrCodeCs/QrDetails')

// 扫码领积分
const ScanCode = () => import('@/page/resint/ScanCode/ScanCodePoints')

//病理杯
const PathologicalCup = () => import('@/page/resint/CathologicalCup/index')

//病理杯投票
const PathologicalCupVote = () => import('@/page/resint/CathologicalCup/Vote')

//病理杯详情
const Particulars = () => import('@/page/resint/CathologicalCup/particulars')

//试用装回购
const Recorder = () => import('@/page/resint/sampleRepurchase/recorder')
const sources = () => import('@/page/resint/sampleRepurchase/sources')



//产品图库
const ProductGallery = () => import('@/page/resint/precinct/productGallery.vue')

//技术文章
const TechnicalArticle = () => import('@/page/resint/precinct/technicalArticle.vue')

//资讯中心
const InformationCenter = () => import('@/page/resint/precinct/informationCenter.vue')

//实验视频
const labVid = () => import('@/page/resint/labVid/index.vue')

const labVidInfo = () => import('@/page/resint/labVid/Info.vue')





//售后服务
const AfterService = () => import('@/page/afterService/index')
const AfterServiceForm = () => import('@/page/afterService/afterServiceFrom')
const AfterServiceList = () => import('@/page/afterService/list')
const AfterServiceInfo = () => import('@/page/afterService/info')
const AfterServiceSupplement = () => import('@/page/afterService/supplement')

const applySuccess = () => import('@/page/afterService/applySuccess')


//定制服务
const CustomService = () => import('@/page/resint/customService/index')
const CustomServiceForm = () => import('@/page/resint/customService/form')




//积分商城
const PointsMall = () => import('@/page/points-mall/PointsMall')
const PointsRecordList = () => import('@/page/points-mall/child/RecordList')

//产品分类
const Category = () => import('@/page/category/category')

//购物车
const Cart = () => import('@/page/cart/cart')



//产品列表
const ProductList = () => import('@/page/product-list/ProductList')
//每日特价、限时特惠
const Special = () => import('@/page/product-list/child/child/SpecialOffer')

// 产品详情
const ProductDetail = () => import('@/page/product-detail/ProductDetail')

//产品活动页
const Activities = () => import('@/page/productEvent/index')
const ActivityCategory = () => import('@/page/productEvent/ActivityCategory')


// search
const Search = () => import('@/page/search/Search')


// checkout
const Checkout = () => import('@/page/checkout/checkout')
const Shipping = () => import('@/page/checkout/Shipping')
const Invoice = () => import('@/page/checkout/Invoice')
const Bonus = () => import('@/page/checkout/child/Bonus')


// payment
const Payment = () => import('@/page/payment/Payment')
const PaySucceed = () => import('@/page/payment/PaySucceed')


//地址
const AddressList = () => import('@/page/address/AddressList')
const AddressEdit = () => import('@/page/address/AddressEdit')


//订单
const Order = () => import('@/page/order/Order')
const OrderDetail = () => import('@/page/order/OrderDetail')
const OrderTrack = () => import('@/page/order/child/OrderTrack')
const OrderTrade = () => import('@/page/order/child/OrderTrade')
const OrderComment = () => import('@/page/order/child/OrderComment')
const OrderSubmit = () => import('@/page/order/child/OrderSubmit')


//我的
const Profile = () => import('@/page/profile/Profile')
const ProfileInfo = () => import('@/page/profile/ProfileInfo')
const Setting = () => import('@/page/profile/Setting')
const ProfileEdit = () => import('@/page/profile/ProfileEdit')
const Collection = () => import('@/page/profile/Collection')
const BrowsingHistory = () => import('@/page/profile/BrowsingHistory')


// auth
const Signin = () => import('@/page/auth/Signin')
const Signup = () => import('@/page/auth/Signup')
const Retrieve = () => import('@/page/auth/Retrieve')
const MobileConfirm = () => import('@/page/auth/mobile/MobileConfirm')
const EmailConfirm = () => import('@/page/auth/email/EmailConfirm')
const EmailResetPassword = () => import('@/page/auth/email/EmailResetPassword')

const Bind = () => import('@/page/auth/Bind')
const BindPhone = () => import('@/page/auth/BindPhone')


//我的积分
const ScoreList = () => import('@/page/score/ScoreList')

//红包
const CashgiftList = () => import('@/page/cashgift/CashgiftList')
const CashgiftUsable = () => import('@/page/cashgift/CashgiftUsable')


// 徽章墙
const BadgeWall = () => import('@/page/badge-wall/BadgeWall')


// 技术文章solarbio
const Solarbio = () => import('@/page/solarbio/solarbio')
const solarbioGywm = () => import('@/page/solarbio/child/child/solarbioGywm')


// const SigninCs = () => import('@/page/auth/SigninCs')

export default [
	{
		path: '/',
		component: App,
		children: [
			{
				path: '',
				redirect: '/home'
			},
			{
				name: 'home',
				path: '/home',
				component: Home,
				meta: {
					isshowtabbar: true
				}
			},
			{
				name: 'solarbio',
				path: '/solarbio',
				component: Solarbio,
				meta: {
					isshowtabbar: true
				}
			},
			{
				name: 'solarbioGywm',
				path: '/solarbioGywm',
				component: solarbioGywm
			},
			{
				name: 'activityCategory',
				path: '/activityCategory',
				component: ActivityCategory,
				meta: {
					title: '活动分类'
				}
			},
			{
				name: 'badgeWall',
				path: '/badge-wall',
				component: BadgeWall,
				meta: {
					title: '徽章墙'
				}
			},
			{
				name: 'exhibition',
				path: '/exhibition',
				component: Exhibition,
			},
			// {
			// 	name: 'SigninCs',
			// 	path: '/SigninCs',
			// 	component: SigninCs,
			// },
			{
				name: 'campusTour',
				path: '/campusTour',
				component: CampusTour,
			},
			{
				name: 'contactUs',
				path: '/contactUs',
				component: ContactUs,
			},
			{
				name: 'technicalServices',
				path: '/technicalServices',
				component: TechnicalServices,
			},
			{
				name: 'technicalServicesInfo',
				path: '/technicalServicesInfo',
				component: TechnicalServicesInfo,
			},
			{
				name: 'sampleSack',
				path: '/sampleSack',
				component: SampleSack,
			},
			{
				name: 'sampleList',
				path: '/sampleList',
				component: SampleList,
			},
			{
				name: 'sampleFeedback',
				path: '/sampleFeedback',
				component: SampleFeedback,
			},
			{
				name: 'noLimitFeedback',
				path: '/noLimitFeedback',
				component: NoLimitFeedback,
			},
			{
				name: 'pointsMall',
				path: '/pointsMall',
				component: PointsMall,
			},
			{
				name: 'pointsRecordList',
				path: '/pointsRecordList',
				component: PointsRecordList,
			},
			{
				name: 'tradeShow',
				path: '/tradeShow',
				component: TradeShow,
				meta: {
					isshowtabbar: true
				}
			},
			{
				name: 'category',
				path: '/category',
				component: Category,
				meta: {
					isshowtabbar: true
				}
			},
			{
				name: 'products',
				path: '/products',
				component: ProductList,
				meta: { keepAlive: true }
			},
			{
				name: 'activities',
				path: '/activities',
				component: Activities,
				meta: { keepAlive: true }
			},
			{
				name: 'special',
				path: '/special',
				component: Special
			},
			{
				name: 'search',
				path: '/search',
				component: Search
			},
			{
				name: 'signin',
				path: '/signin',
				component: Signin
			},
			{
				name: 'signup',
				path: '/signup',
				component: Signup
			},
			{
				name: 'retrieve',
				path: '/retrieve',
				component: Retrieve
			},
			{
				name: 'mobileConfirm',
				path: '/mobileConfirm',
				component: MobileConfirm
			},
			{
				name: 'emailConfirm',
				path: '/emailConfirm',
				component: EmailConfirm
			},
			{
				name: 'resetPassword',
				path: '/resetPassword',
				component: EmailResetPassword
			},
			{
				name: 'bind',
				path: '/bind',
				component: Bind
			},
			{
				name: 'bindPhone',
				path: '/bindPhone',
				component: BindPhone
			},
			{
				name: 'profile',
				path: '/profile',
				component: Profile,
				meta: {
					isshowtabbar: true
				}
			},
			{
				name: 'setting',
				path: '/setting',
				component: Setting
			},
			{
				name: 'profileInfo',
				path: '/profileInfo',
				component: ProfileInfo
			},
			{
				name: 'Collection',
				path: '/collection',
				component: Collection
			},
			{
				name: 'BrowsingHistory',
				path: '/browsingHistory',
				component: BrowsingHistory
			},
			{
				name: 'addressList',
				path: '/addressList',
				component: AddressList
			},
			{
				name: 'addressEdit',
				path: '/addressManage/addressEdit',
				component: AddressEdit,
				meta: {
					keepAlive: false
				}
			},
			{
				name: 'cashgiftList',
				path: '/cashgiftList',
				component: CashgiftList
			},
			{
				name: 'cashgiftUsable',
				path: '/checkout/cashgiftUsable',
				component: CashgiftUsable,
				meta: {
					keepAlive: true
				}
			},
			{
				name: 'checkout',
				path: '/checkout/:isExchange?/:exchangeScore?/:isCart?',
				component: Checkout,
				meta: {
					keepAlive: false
				}
			},
			{
				name: 'payment',
				path: '/payment',
				component: Payment
			},
			{
				name: 'paySucceed',
				path: '/paySucceed',
				component: PaySucceed
			},
			{
				name: 'shipping',
				path: '/checkout/shipping',
				component: Shipping
			},
			{
				name: 'invoice',
				path: '/checkout/invoice',
				component: Invoice
			},
			{
				name: 'bonus',
				path: '/bonus',
				component: Bonus
			},
			{
				name: 'order',
				path: '/order/:order?',
				component: Order
			},
			{
				name: 'orderDetail',
				path: '/orderDetail/:orderDetail?',
				component: OrderDetail
			},
			{
				name: 'orderTrack',
				path: '/orderTrack/:orderTrack?',
				component: OrderTrack
			},
			{
				name: 'orderTrade',
				path: '/orderTrade',
				component: OrderTrade
			},
			{
				name: 'orderComment',
				path: '/orderComment',
				component: OrderComment
			},
			{
				name: 'orderSubmit',
				path: '/orderSubmit',
				component: OrderSubmit
			},
			{
				name: 'product',
				path: '/product/:id?/:productId?',
				component: ProductDetail,
			},
			{
				name: 'cart',
				path: '/cart',
				component: Cart,
				meta: {
					isshowtabbar: true,
				}
			},
			{
				name: 'profileEdit',
				path: '/profileEdit/:type',
				component: ProfileEdit
			},
			{
				name: 'scoreList',
				path: '/scoreList',
				component: ScoreList
			},
			{
				name: 'lotteryContest',
				path: '/lotteryContest',
				component: LotteryContest
			},
			{
				name: 'newYearHelp',
				path: '/newYearHelp',
				component: newYearHelp
			},
			{
				name: 'newYearList',
				path: '/newYearList',
				component: newYearList
			},
			{
				name: 'premium_courses',
				path: '/premium_courses',
				component: PremiumCourses
			},
			{
				name: 'ktApply',
				path: '/ktApply',
				component: KtApply
			},
			{
				name: 'QrCodecs',
				path: '/QrCodecs',
				component: QrCodecs
			},
			{
				name: 'QrDetailscs',
				path: '/QrDetailscs',
				component: QrDetailscs
			},
			{
				name: 'QrCode',
				path: '/QrCode',
				component: QrCode
			},
			{
				name: 'QrDetails',
				path: '/QrDetails',
				component: QrDetails
			},
			{
				name: 'scanCode',
				path: '/scanCode',
				component: ScanCode
			},
			{
				name: 'pathologicalCup',
				path: '/pathologicalCup',
				component: PathologicalCup
			},
			{
				name: 'pathologicalCupVote',
				path: '/pathologicalCupVote',
				component: PathologicalCupVote
			},
			{
				name: 'particulars',
				path: '/particulars',
				component: Particulars
			},
			{
				name: 'activityJxj',
				path: '/activityJxj',
				component: activityJxj
			},
			{
				name: 'newMore',
				path: '/newMore',
				component: newMore
			},
			{
				name: 'newsDetail',
				path: '/newsDetail',
				component: NewsDetail
			},
			{
				name: 'xhtlMore',
				path: '/xhtlMore',
				component: xhtlMore
			},
			{
				name: 'xhtlDeta',
				path: '/xhtlDeta',
				component: xhtlDeta
			},
			{
				name: 'marchActivities',
				path: '/marchActivities',
				component: MarchActivities
			},
			{
				name: 'recorder',
				path: '/recorder',
				component: Recorder
			},
			{
				name: 'sources',
				path: '/sources',
				component: sources
			},
			{
				name: 'afterService',
				path: '/afterService',
				component: AfterService
			},
			{
				name: 'afterServiceForm',
				path: '/afterServiceForm',
				component: AfterServiceForm
			},
			{
				name: 'afterServiceList',
				path: '/afterServiceList',
				component: AfterServiceList,
				meta: { keepAlive: true }
			},
			{
				name: 'afterServiceInfo',
				path: '/afterServiceInfo',
				component: AfterServiceInfo
			},
			{
				name: 'afterServiceSupplement',
				path: '/afterServiceSupplement',
				component: AfterServiceSupplement
			},
			{
				name: 'applySuccess',
				path: '/applySuccess',
				component: applySuccess
			},
			{
				name: 'informationCenter',
				path: '/informationCenter',
				component: InformationCenter,
				meta: { keepAlive: true }
			},
			{
				name: 'labVid',
				path: '/labVid',
				component: labVid,
				meta: { keepAlive: true }
			},
			{
				name: 'labVidInfo',
				path: '/labVidInfo',
				component: labVidInfo
			},
			{
				name: 'productGallery',
				path: '/productGallery',
				component: ProductGallery,
				meta: { keepAlive: true }
			},
			{
				name: 'technicalArticle',
				path: '/technicalArticle',
				component: TechnicalArticle,
				meta: { keepAlive: true }
			},
			{
				name: 'customService',
				path: '/customService',
				component: CustomService,
				// meta: { keepAlive: true }
			},
			{
				name: 'customServiceForm',
				path: '/customServiceForm',
				component: CustomServiceForm
			},
			{
				path: '*',
				redirect: '/'
			},
		]
	}
]

// const router = new VueRouter({
//   mode: 'history', //路由模式(默认为hash模式)
// 	debug: true
// })


// WEBPACK FOOTER //
// ./src/router/router.js